import Particles from "react-particles-js";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import AboutMe from "./components/AboutMe/AboutMe.jsx";
import ContactMe from "./components/ContactMe/ContactMe.jsx";
import Footer from "./components/Footer/Footer.jsx";
import Header from "./components/Header/Header.jsx";
import MyBlog from "./components/MyBlogs/MyBlog.jsx";
import Navbar from "./components/Navbar/Navbar.jsx";
import Projects from "./components/Projects/Projects.jsx";
import Resume from "./components/Resume/Resume.jsx";
import Services from "./components/Services/Services.jsx";
import Skills from "./components/Skills/Skills";

function App() {
  return (
    <>
      <Particles
        params={{
          particles:{
            number:{
              value:50,
              density:{
                enable:true,
                value_area:900
              }
            },
            shape:{
              type:"circle",
              stroke:{
                width:6,
                color:"#ffff"
              }
            } 
          }
        }}
      />
      <Navbar />
      <Header />
      <AboutMe/>
      <Skills/>
      <Projects/>
      <Resume/>
      <Services/>
      <MyBlog/>
      <ContactMe/>
      <Footer/>
    </>
  );
}

export default App;
